export default {
  name: "",
  displayName: "",
  description: "",
  priceSort: 0,
  vendorCut: 0
};
